import React from 'react';
import styled from 'styled-components';

import { CommonDialog } from '../common';
import type { CommonDialogProps } from '../common/types';

interface Props {
  message: string;
  ButtonComponent?: () => React.ReactNode;
}

const Message = styled.p`
  margin-right: auto;
  margin-top: ${({ theme }) => theme.padding.smallest};
`;

export const AlertDialog = ({
  message,
  ButtonComponent,
  ...props
}: Props & CommonDialogProps) => {
  return (
    <CommonDialog {...props} ButtonComponent={ButtonComponent}>
      <Message>{message}</Message>
    </CommonDialog>
  );
};
